import { FC } from 'react'
import { Close } from '../../icons'
import { useTagSelect } from './hooks'
import { Root, Tag } from './primitives'

interface Props {
  tags: string[]
  isDisabled?: boolean
  value: string[]
  variant?: 'default' | 'ai' | 'rounded'
  onChange: (selected: string[]) => void
}

export const TagSelect: FC<Props> = ({
  tags,
  isDisabled,
  value,
  variant = 'default',
  onChange
}) => {
  const { selected, handleSelect, handleRemove } = useTagSelect({ value, onChange })

  const handleClick = ({ isSelected, tag }: { isSelected: boolean; tag: string }) => {
    if (isDisabled) {
      return
    }

    return isSelected ? handleRemove(tag) : handleSelect(tag)
  }

  return (
    <Root>
      {tags.map((tag, index) => {
        const isSelected = selected.includes(tag)

        return (
          <Tag
            key={`${tag}-${index}`}
            selected={isSelected}
            onClick={() => handleClick({ isSelected, tag })}
            color={variant}
            disabled={isDisabled}
          >
            {tag}
            {isSelected && <Close />}
          </Tag>
        )
      })}
    </Root>
  )
}
